import POSFunctions from './POSFunctions';

export default {
  title: 'POS Functions',
  description: 'Here you can choose what is visible at the POS sales view.',
  path: '/pos-settings/pos-functions',
  component: POSFunctions,
  rootPath: { name: 'POS Settings', uri: '/pos-settings' },
  subPath: [{ name: 'POS Functions' }],
};
